import { classicMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

export default function ClassicPicks() {
  return (
    <section id="classic" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="经典高分 · 值得重看"
          title="被时间留下的高分佳作"
          desc="这些影片经过修复后重新上线，画质与音轨都有提升。如果你喜欢慢下来细看的作品，不妨从这份片单开始。"
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {classicMovies.map((m, idx) => (
            <article
              key={m.id}
              className="group flex gap-4 md:gap-5 p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-24 md:w-32 shrink-0">
                <div className="rounded-md overflow-hidden aspect-[2/3] bg-background-200">
                  <img
                    src={m.poster}
                    alt={`${m.title} 经典影片海报，${m.genres.join('、')}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <span className="absolute -top-2 -left-2 w-8 h-8 rounded-full bg-primary-500 text-background-50 font-heading font-bold text-sm flex items-center justify-center">
                  {idx + 1}
                </span>
              </div>
              <div className="flex-1 min-w-0 flex flex-col">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-bold text-lg text-foreground-950">{m.title}</h3>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px]">
                    {m.quality}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500">
                  {m.year} · {m.region} · {m.genres.join(' / ')}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{m.synopsis}</p>
                <div className="mt-auto pt-4 flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 text-accent-700">
                    <i className="ri-star-fill"></i>
                    评分 {m.rating}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-timer-line"></i>
                    {m.duration}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}